import { configEnableTrue } from "../../common/components/PivotTable/commonPropertyConfig";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { AgFormat } from "../../common/utils/agGridFormat";
import { Functions } from "../../common/utils/clientlistHelper";

export function getAllScHeaders(): {
  attributeHeaders: any[];
  kpiHeaders: any[];
} {
  const defaultNumberCellStyle = {
    "padding-right": "40px",
    "text-align": "right",
  };
  return {
    attributeHeaders: getAllAttributesHeaders(),
    kpiHeaders: GetKpisHeaders(defaultNumberCellStyle),
  };
}
// tslint:disable-next-line: no-big-function
function getAllAttributesHeaders() {
  return [
    {
      cellRenderer: Functions.hlinkFunction,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LEID,
      headerName: "Final Com LE Id",
    },
    {
      cellRenderer: Functions.hlinkFunction,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LENAME,
      headerName: "Final Com LE Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: "client_subgrpid",
      headerName: "Final Com SubGrp Id",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_SUBGROUPNAME,
      headerName: "Final Com SubGrp Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_GRPID,
      headerName: "Final Com Grp Id",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_GROUPNAME,
      headerName: "Final Com Grp Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_COM_ID,
      headerName: "Final Com EC Id",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_FULLNAME,
      headerName: "Final Com EC Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL1,
      headerName: "Product Level 1",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL2,
      headerName: "Product Level 2",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL3,
      headerName: "Product Level 3",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SUBMNEMO,
      headerName: "Trader Sub Business Unit Mnemo",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_LABEL,
      headerName: "Trader Profit Center",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_PC,
      headerName: "Trader Profit Center Mnemo",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      headerName: "Client Country",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_COM_CTRY,
      headerName: "Client EC country",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_SALESBEN_SALES,
      headerName: "Sales",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_SALESBEN_TEAM,
      headerName: "Sales Team",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SSBL,
      headerName: "Trader Sub Sub Business Line",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SBU,
      headerName: "Trader Sub Business Unit",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SSBL,
      headerName: "Sales Sub Sub Business Line",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_LABEL,
      headerName: "Sales Profit Center",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_PCMNEMO,
      headerName: "Sales Profit Center Mnemo",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_OE_RES_REG_CODE,
      headerName: "Originating Region",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_BE_SHORT_LABEL,
      headerName: "Booking Entity",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_GOP,
      headerName: "Sales Operating Group",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_REGION,
      headerName: "Sales Region",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_ZONE,
      headerName: "Sales Zone",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_COUNTRY,
      headerName: "Sales Country",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L1,
      headerName: "Business Level 1",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L2,
      headerName: "Business Level 2",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L3,
      headerName: "Business Level 3",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_BE_SHORT_MNEMO,
      headerName: "Booking Entity Mnemo",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPO_L1,
      headerName: "Client - LE - Typology Level 1",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPEL2_NAME,
      headerName: "Client - LE - Typology Level 2",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPEL3_NAME,
      headerName: "Client - LE - Typology Level 3",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_REG_NAME,
      headerName: "Client - LE - Region Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_SUBREG_NAME,
      headerName: "Client - LE - Sub Region Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_CTRY_GRP_NAME,
      headerName: "Client - LE - Country Grouping Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FINAL_CLIENT_CAMBIST_NAME,
      headerName: "Client - EC - Cambist Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_BUSTYPE,
      headerName: "Business Type",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_TRADE_BE_SHORT_MNEMO,
      headerName: "Trader Booking Entity Mnemo",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_CATEGORY_NAME,
      headerName: "Product Category Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL4,
      headerName: "Product Level 4",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARKDEALS_PRODUCT_FAMILY_NAME,
      headerName: "Product Family Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARKDEALS_EQYFI,
      headerName: "Equity/fixed Income Deals",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_NOMINAL_CURRENCY,
      headerName: "Nominal Currency",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_NEGOTIATED_CURRENCY,
      headerName: "Negotiated Currency",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_COUNTRY,
      headerName: "Mandate Country",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_REGION,
      headerName: "Mandate Region",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_ZONE,
      headerName: "Mandate Zone",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_IS_ELEC,
      headerName: "Is Elec",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_AGENCY_DR_NAME,
      headerName: "Agency DR Name",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY,
      headerName: "Deal Currency",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY_EMG10,
      headerName: "Deal Currency EM/G10",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY_ZONES,
      headerName: "Deal Currency Zones",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SBUMNEMO,
      headerName: "Sales - sub business unit",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_INVFLOWFIN,
      headerName: "FPV Trd - Inv. Sol./Flow/Fin.",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_TEAM_ACTIVITY,
      headerName: "Team Activity Label",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_TEAM_DESK,
      headerName: "Team Desk Label",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SALESBEN_SALES_LOCATION,
      headerName: "Sales Location",
    },
    {
      cellRenderer: Functions.suppressCount,
      ...configEnableTrue,
      field: SCAttributes.SC_DEAL_X_ONE_INSTRUMENT,
      headerName: "Deal - X-One Instrument",
    },
  ];
}
// tslint:disable-next-line: no-big-function
function GetKpisHeaders(defaultNumberCellStyle: {
  "padding-right": string;
  "text-align": string;
}) {
  const defaultPercentCellClass = "text-right percent";
  return [
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd",
      headerName: "SC YTD (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellClass: defaultPercentCellClass,
      cellRenderer: Functions.calculateNbiVar,
      comparator: AgFormat.AgNumberComparatorNumeric,
      enableValue: true,
      field: "sc_ytd_var_yoy",
      headerName: "SC YTD var YoY",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd_1",
      headerName: "SC YTD-1 (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd_usd",
      headerName: "SC YTD (K$)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd_usd_1",
      headerName: "SC YTD-1 (K$)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "nominal_ytd",
      headerName: "Nominal",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_fy",
      headerName: "SC FY",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_fy_1",
      headerName: "SC FY-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "volumes_ytd",
      headerName: "Volumes YTD",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "volumes_ytd_1",
      headerName: "Volumes YTD-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_mtd",
      headerName: "SC MTD (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_mtd_1",
      headerName: "SC MTD-1 (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellClass: defaultPercentCellClass,
      cellRenderer: Functions.calculateNbiVar,
      comparator: AgFormat.AgNumberComparatorNumeric,
      enableValue: true,
      field: "sc_mtd_yoy",
      headerName: "SC MTD var (%)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd_2",
      headerName: "SC YTD-2 (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_ytd_3",
      headerName: "SC YTD-3 (K€)",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_budget_sales",
      headerName: "Budget Sales",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_budget_team",
      headerName: "Budget Team",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_budget_pc",
      headerName: "Budget Profit Center",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_budget_sbu",
      headerName: "Budget Sub Business Unit",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_budget_bu",
      headerName: "Budget Business Unit",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_mtd_step1",
      headerName: "SC MTD Step 1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_sc_2",
      headerName: "SC FY-2",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_com_ytd",
      headerName: "Commission YTD",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_com_ytd_1",
      headerName: "Commission YTD-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_csa_ytd",
      headerName: "CSA YTD",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_csa_ytd_1",
      headerName: "CSA YTD-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_fees_ytd",
      headerName: "Fees YTD",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_fees_ytd_1",
      headerName: "Fees YTD-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_tr_pnl_ytd",
      headerName: "Trading Pnl YTD",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_tr_pnl_ytd_1",
      headerName: "Trading Pnl YTD-1",
      width: 160,
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.formatMoneyNoDecimal,
      cellStyle: defaultNumberCellStyle,
      enableValue: true,
      field: "sc_markup_ytd",
      headerName: "YTD Mark Up",
      width: 160,
    },
  ];
}
